<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          v-if="this.venteLotId"
          :confirm="askConfirm"
          :title="$t('Edit') + ' ' + this.venteLotName"/>
        <back-arrow
          v-else
          :confirm="askConfirm"
          :title="$t('Add') + ' ' + $t('venteLot.add')"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

              <div class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('venteLot.lotInfos') }}
                </span>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.operation.invalidFeedback"
                    class="medium-label mb-4 flex-row"
                    label-for="operation-input">
                    <b-tooltip target="info-circle-construction-start" html variant="dark">
                      {{ $t('lot.add.operation.info') }}
                    </b-tooltip>
                    <label id="operation-input-label" for="operation-input-input">{{ $t('Operation') }}</label>
                    <b-icon id="info-circle-construction-start" class="ml-2" icon="info-circle"
                            variant="primary"></b-icon>
                    <b-form-select
                      id="operation-input"
                      v-model="form.operation.value"
                      :disabled="!!(this.venteLotId)"
                      :state="form.operation.state"
                      required
                      v-on:change="getOperationLots($event)">
                      <option v-for="option in operationList" :value="option.id">
                        {{ $t(option.name) }}
                      </option>
                    </b-form-select>

                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.operationLot.invalidFeedback"
                    :label="$t('venteLot.OperationLot')"
                    class="medium-label mb-4"
                    label-for="operationLot-input">
                    <b-form-select
                      id="operationLot-input"
                      v-model="form.operationLot.value"
                      :disabled="!!(this.venteLotId)"
                      :state="form.operationLot.state"
                      required
                      v-on:change="manageLotData($event)">
                      <option v-for="option in operationLotList" :value="option.id">
                        {{ $t(option.name) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.statut.invalidFeedback"
                    :label="$t('venteLot.Statut')"
                    class="medium-label mb-4"
                    label-for="statut-input">
                    <b-form-select
                      id="statut-input"
                      v-model="form.statut.value"
                      :state="form.statut.state"
                      required
                      v-on:change="askConfirm=true;">
                      <option v-for="option in statutList" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.address.invalidFeedback"
                    :label="$t('venteLot.Address')"
                    :state="form.address.state"
                    class="mb-4"
                    label-for="address-input">
                    <b-form-input
                      id="address-input"
                      v-model="form.address.value"
                      :state="form.address.state"
                      maxlength="250"
                      required
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.postalCode.invalidFeedback"
                    :label="$t('venteLot.PostalCode')"
                    :state="form.postalCode.state"
                    class="mb-4"
                    label-for="postalCode-input">
                    <b-form-input
                      id="postalCode-input"
                      v-model="form.postalCode.value"
                      :state="form.postalCode.state"
                      maxlength="5"
                      required
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.city.invalidFeedback"
                    :label="$t('venteLot.City')"
                    :state="form.city.state"
                    class="mb-4"
                    label-for="city-input">
                    <b-form-input
                      id="city-input"
                      v-model="form.city.value"
                      :state="form.city.state"
                      maxlength="250"
                      required
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('venteLot.venteInfos') }}
                </span>
              </div>

              <div class="row">

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.surface.invalidFeedback"
                    :label="$t('venteLot.Surface')"
                    :state="form.surface.state"
                    class="mb-4"
                    label-for="surface-input">
                    <b-input-group>
                      <b-form-input
                        id="surface-input"
                        v-model="form.surface.value"
                        v-disable-scroll
                        min="0"
                        required
                        step="any"
                        type="number"
                        v-on:change="askConfirm=true;">
                      </b-form-input>
                      <b-input-group-append>m²</b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.etage.invalidFeedback"
                    :label="$t('venteLot.Etage')"
                    class="medium-label mb-4"
                    label-for="etage-input">
                    <b-form-select
                      id="etage-input"
                      v-model="form.etage.value"
                      :state="form.etage.state"
                      v-on:change="askConfirm=true;">
                      <option v-for="option in etageList" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>


                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.brutRenove.invalidFeedback"
                    :label="$t('venteLot.BrutRenove')"
                    class="medium-label mb-4"
                    label-for="brutRenove-input">
                    <b-form-select
                      id="brutRenove-input"
                      v-model="form.brutRenove.value"
                      :state="form.brutRenove.state"
                      required
                      v-on:change="askConfirm=true;">
                      <option v-for="option in brutRenoveList" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.type.invalidFeedback"
                    :label="$t('venteLot.Type')"
                    :state="form.type.state"
                    class="mb-4"
                    label-for="type-input">
                    <b-form-input
                      id="type-input"
                      v-model="form.type.value"
                      :state="form.type.state"
                      maxlength="250"
                      required
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.lotCoPro.invalidFeedback"
                    :label="$t('venteLot.LotCoPro')"
                    :state="form.lotCoPro.state"
                    class="mb-4"
                    label-for="lotCoPro-input">
                    <b-form-input
                      id="lotCoPro-input"
                      v-model="form.lotCoPro.value"
                      :state="form.lotCoPro.state"
                      maxlength="250"
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.prixVente.invalidFeedback"
                    :label="$t('venteLot.PrixVente')"
                    :state="form.prixVente.state"
                    class="mb-4"
                    label-for="prixVente-input">
                    <b-input-group>
                      <b-form-input
                        id="prixVente-input"
                        v-model="form.prixVente.value"
                        v-disable-scroll
                        min="0"
                        required
                        step="any"
                        type="number"
                        v-on:change="askConfirm=true;">
                      </b-form-input>
                      <b-input-group-append>€</b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>

                <div class="col-md-8">
                  <b-form-group
                    :invalid-feedback="form.description.invalidFeedback"
                    :label="$t('venteLot.Description')"
                    :state="form.description.state"
                    class="mb-4"
                    label-for="description-input">
                    <b-form-textarea
                      id="description-input"
                      v-model="form.description.value"
                      :state="form.description.state"
                      maxlength="1000"
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-textarea>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('venteLot.Documents') }}
                </span>
              </div>

              <div class="row">
                <div v-for="(document, index) in documents" :key="index" class="col-md-12">
                  <div class="row align-items-center">
                    <div class="col-md-5">
                      <b-form-group
                        :invalid-feedback="document.file.invalidFeedback"
                        :label="$t('OperationDocument')"
                        :label-for="`document[${index}][file]-index`"
                        :state="document.file.state"
                        class="medium-label mb-4">
                        <custom-form-file
                          :id="`document[${index}][file]-index`"
                          v-model="document.file.value"
                          :browse-text="$t('Select')"
                          :disabled="document.id"
                          :placeholder="document.currentFile ? document.currentFile:  $t('Select') + ' ' + $t('a') + ' ' + $t('contactDocument.file')"
                          :required="document.id == null"
                          :state="document.file.state"
                          @change="askConfirm=true;"
                          @input="setName(document)"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <b-form-group
                        :label="$t('OperationDocument.name')"
                        :label-for="`document[${index}][name]-index`"
                        class="medium-label mb-4">
                        <b-form-input
                          :id="`document[${index}][name]-index`"
                          v-model="document.name.value"
                          maxlength="250"
                          required
                          type="text"
                          v-on:change="askConfirm=true;">
                        </b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-1">
                      <button class="show-action-btn delete" @click="clickOnDeleteBtnDocument($event, document, index)">
                        <trash-icon size="18"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <b-button class="btn-medium" variant="outline" @click="addDocument()">
                <plus-icon class="mr-1" size="16"/>
                {{ $t('Add') }} {{ $t('contactDocument') }}
              </b-button>

              <div class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('venteLot.Photos.Annonce') }}
                </span>
              </div>

              <div class="row">
<!--                <div class="col-md-5">
                  <b-form-group
                    :invalid-feedback="currentPhoto.file.invalidFeedback"
                    :label="$t('venteLot.Photos')"
                    :state="currentPhoto.file.state"
                    class="medium-label mb-4"
                    label-for="photo-input">
                    <b-form-file
                      id="photo-input"
                      v-model="currentPhoto.file.value"
                      :browse-text="$t('Select')"
                      :state="currentPhoto.file.state"
                      accept=".png, .jpeg, .jpg"
                      @change="previewImage"
                      v-on:input="addPhoto()">
                    </b-form-file>
                  </b-form-group>
                </div>-->

                <div class="col-md-5">
                  <b-form-group
                    :invalid-feedback="currentPhoto.file.invalidFeedback"
                    :label="$t('venteLot.Photos')"
                    :state="currentPhoto.file.state"
                    class="medium-label mb-4"
                    label-for="photo-input">
                    <custom-form-file
                      id="photo-input"
                      v-model="currentPhoto.file.value"
                      :browse-text="$t('Select')"
                      :state="currentPhoto.file.state"
                      accept=".png, .jpeg, .jpg"
                      multiple
                      @change="previewImage"
                      @input="addPhoto"
                    />
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div v-for="(photo, index) in existingPhotos" class="col-md-2 p-0 ml-3">
                  <img :key="index" :src="photo.fileUrl" alt="Image preview" class="rounded"
                       height="auto"
                       width="100%"/>
                  <button class="show-action-btn delete position-absolute deletephoto"
                          @click="clickOnDeleteExistingBtnPhoto($event, index)">
                    <trash-icon size="18"/>
                  </button>
                </div>
                <div v-for="(photo, index) in photoPreviews" class="col-md-2 p-0 ml-3">
                  <img :key="index" :src="photo" alt="Image preview" class="rounded"
                       height="auto"
                       width="100%"/>
                  <button class="show-action-btn delete position-absolute deletephoto"
                          @click="clickOnDeleteBtnPhoto($event, index)">
                    <trash-icon size="18"/>
                  </button>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <b-button
                  tabindex="5"
                  type="submit"
                  variant="primary"
                  :disabled="isLoading"
                >
                  <b-spinner
                    v-if="isLoading"
                    small
                    class="mr-2"
                  ></b-spinner>
                  <div v-else>
                    {{ $t('Validate') }}
                  </div>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";

export default {

  name: 'VenteLotCreateEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    CustomFormFile
  },

  data() {
    return {
      isLoading:false,
      venteLotId: this.$route.params.venteLotId,
      venteLotName: "",
      askConfirm: false,
      operationList: [],
      operationLotList: [],
      statutList: [],
      documents: [],
      currentPhoto: {
        id: null,
        file:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      documentsIdsToRemove: [],
      photos: [],
      existingPhotos: [],
      photoPreviews: [],
      brutRenoveList: [],
      etageList: [],
      form: {
        operation:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        operationLot:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        statut:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lotCoPro:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        type:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        surface:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixVente:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        brutRenove:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        etage:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        description:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
      },
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    previewImage(event) {
      this.askConfirm = true;
      const files = event.target.files;

      // Clear the existing previews
      this.photoPreviews = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          this.photoPreviews.push(e.target.result);
        };

        reader.readAsDataURL(file);
      }
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    async fetchData() {
      await this.getStatutVentes()
      await this.getStatutLot()
      await this.getEtages()
      if (this.venteLotId) {
        await this.fetchVenteLot()
      } else {
        await this.getOperations()
      }
    },

    async fetchVenteLot() {
      api
        .get(`/venteLot/${this.venteLotId}`)
        .then(async response => {
          this.venteLotName = response.data.operationLot.tostring
          this.form.address.value = response.data.address
          this.form.city.value = response.data.city
          this.form.postalCode.value = response.data.postalCode
          this.form.lotCoPro.value = response.data.lotCoPro
          this.form.surface.value = response.data.surface
          this.form.etage.value = response.data.etage
          this.form.brutRenove.value = response.data.brutRenove
          this.form.description.value = response.data.description
          this.form.type.value = response.data.type
          this.form.prixVente.value = response.data.prix
          this.form.statut.value = response.data.statut

          this.operationList.push(response.data.operation)
          this.form.operation.value = response.data.operation.id

          this.operationLotList.push(response.data.operationLot)
          this.form.operationLot.value = response.data.operationLot.id


          await this.fetchDocuments()
          await this.fetchPhotos()

        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async fetchPhotos() {
      api
        .get(`/venteLotDocument/getPhotos/${this.venteLotId}`)
        .then(response => {
          response.data.forEach((photo) => {
            this.existingPhotos.push({
              id: photo.id,
              fileUrl: photo.fileUrl,
              name: photo.fileName
            })
          })

        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async fetchDocuments() {
      api
        .get(`/venteLotDocument/getDocuments/${this.venteLotId}`)
        .then(response => {
          response.data.forEach((document) => {
            this.documents.push({
              id: document.id,
              currentFile: document.name,
              name:
                {
                  state: null,
                  invalidFeedback: null,
                  value: document.name
                },
              file:
                {
                  state: null,
                  invalidFeedback: null,
                  value: null
                }
            })
          })
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async getStatutVentes() {
      api
        .get(`/venteLot/getStatutVentes`)
        .then(response => {
          this.statutList = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'VenteLotIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getStatutLot() {
      api
        .get(`/venteLot/getStatutLot`)
        .then(response => {
          this.brutRenoveList = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'VenteLotIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getEtages() {
      api
        .get(`/venteLot/getEtages`)
        .then(response => {
          this.etageList = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'VenteLotIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    addDocument() {
      this.documents.push({
        id: null,
        currentFile: null,
        name:
          {
            state: null,
            invalidFeedback: null,
            value: ''
          },
        file:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      })
    },

    setName(document) {
      document.name.value = document.file.value.name
    },

    addPhoto() {
      const files = this.currentPhoto.file.value;

      for (let i = 0; i < files.length; i++) {
        this.photos.push({
          id: null,
          file: files[i],
          name: files[i].name
        });
      }

      this.currentPhoto = {
        file: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      };
    },

    clickOnDeleteBtnDocument(event, document, index) {
      event.preventDefault()
      if (document.id) {
        this.documentsIdsToRemove.push(document.id)
      }
      this.documents.splice(index, 1)
    },

    clickOnDeleteBtnPhoto(event, index) {
      event.preventDefault()
      this.photoPreviews.splice(index, 1)
      this.photos.splice(index, 1)
    },

    clickOnDeleteExistingBtnPhoto(event, index) {
      event.preventDefault()
      if (this.existingPhotos.at(index).id) {
        this.documentsIdsToRemove.push(this.existingPhotos.at(index).id)
        this.existingPhotos.splice(index, 1)
      }
    },

    async getOperations() {
      api
        .get(`/operation/getAllOperationNamesNotAvp`)
        .then(response => {
          this.operationList = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'VenteLotIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getOperationLots(operationId) {
      if (!this.venteLotId) {
        await api
          .get(`/venteLot/getAllLotForOperation/${operationId}`)
          .then(response => {
            this.operationLotList = response.data
          })
      }
    },

    manageLotData(operationLotId) {
      let operationLot = this.operationLotList.find(operationLot => operationLot.id === operationLotId)
      this.form.address.value = operationLot.operation.address
      this.form.city.value = operationLot.operation.city
      this.form.postalCode.value = operationLot.operation.postalCode
      this.form.lotCoPro.value = operationLot.lotCoPro
      this.form.surface.value = operationLot.surface
      this.form.etage.value = operationLot.etage.value
      this.form.prixVente.value = operationLot.prixVenteTTC
      this.form.brutRenove.value = operationLot.type.value
      this.form.type.value = operationLot.name
    },

    onSubmit() {
      this.isLoading = true;
      let data = new FormData();
      let url = 'venteLot';
      if (this.venteLotId) {
        url = '/venteLot/' + this.venteLotId;
      } else {
        data.append('operation', this.form.operation.value);
        data.append('operationLot', this.form.operationLot.value);
      }
      data.append('statut', this.form.statut.value);
      data.append('address', this.form.address.value);
      data.append('postalCode', this.form.postalCode.value);
      data.append('city', this.form.city.value);
      data.append('surface', this.form.surface.value);
      data.append('etage', this.form.etage.value);
      data.append('brutRenove', this.form.brutRenove.value);
      data.append('type', this.form.type.value);
      data.append('lotCoPro', this.form.lotCoPro.value);
      data.append('prixVente', this.form.prixVente.value);
      data.append('description', this.form.description.value);

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(async (response) => {
          const documentPromises = this.documents.map(doc => {
            let data = new FormData();
            data.append('document', doc.file.value);
            data.append('documentName', doc.name.value);
            data.append('type', 'VENTE_LOT_DOCUMENT');
            if (this.venteLotId) {
              data.append('venteLotId', this.venteLotId);
            } else {
              data.append('venteLotId', response.data.id);
            }
            if (doc.id) {
              data.append('docId', doc.id);
            }

            const url = doc.id ? `/venteLotDocument/${doc.id}` : '/venteLotDocument';
            return api({
              method: 'POST',
              url: url,
              data: data,
            });
          });


          // Handle photos
          const photoPromises = this.photos.map(photo => {
            let data = new FormData();
            data.append('document', photo.file);
            data.append('documentName', photo.name);
            data.append('type', 'VENTE_LOT_PHOTO');
            if (this.venteLotId) {
              data.append('venteLotId', this.venteLotId);
            } else {
              data.append('venteLotId', response.data.id);
            }

            const url = photo.id ? `/venteLotDocument/${photo.id}` : '/venteLotDocument';
            return api({
              method: 'POST',
              url: url,
              data: data,
            });
          });

          const deletePromises = this.documentsIdsToRemove.map(documentIdToDelete =>
            api.delete(`/venteLotDocument/${documentIdToDelete}`)
          );

          await Promise.all([
            ...documentPromises,
            ...photoPromises,
            ...deletePromises,
          ]);


          this.$router.push({
            name: 'VenteLotIndex'
          }, () => {
            this.$nextTick(() => {
              if (url === 'venteLot') {
                this.successToast(this.$i18n.t('venteLot.OperationLotAdded'));
              } else {
                this.successToast(this.$i18n.t('venteLot.OperationLotEdited'));
              }
            });
          });
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'VenteLotIndex',
              params: {
                message: error.response.data.message
              }
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
      this.form[field]['invalidFeedback'] = null
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
input::placeholder {
  opacity: 0.25;
  color: var(--main-text-color);
}

.deletephoto {
  top: 15px;
  right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/venteLot/VenteLotCreateEdit.vue